$(document).on('turbolinks:load', function() {
  // プレビューボタンの data-disabled が独立して外せないので力技
  $('.card-footer .btn.preview').click(function () {
    setTimeout(function () {
      $('.card-footer .btn').prop('disabled', false);
    }, 1000);
  });
});

